exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".month-year p[data-v-6d22135f]{font-size:24px;color:#ffb300}.month-year span[data-v-6d22135f]{color:rgba(0,0,0,.67)}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/InvoiceDetails.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,aAAe,CAChB,AACD,kCACE,qBAA2B,CAC5B","file":"InvoiceDetails.vue","sourcesContent":["\n.month-year p[data-v-6d22135f] {\n  font-size: 24px;\n  color: #FFB300;\n}\n.month-year span[data-v-6d22135f] {\n  color: rgba(0, 0, 0, 0.67);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d22135f","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/modals/InvoiceDetails.vue
// module id = 528
// module chunks = 2